// extracted by mini-css-extract-plugin
export default {"wrapper":"bA-z","viewport":"cA-z","container":"dA-z","slide":"eA-z"};